import { render, staticRenderFns } from "./instituciones.vue?vue&type=template&id=8e6b0f4c"
import script from "./instituciones.vue?vue&type=script&lang=js"
export * from "./instituciones.vue?vue&type=script&lang=js"
import style0 from "./instituciones.vue?vue&type=style&index=0&id=8e6b0f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports